import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark px-4 py-3">
      <div className="container-fluid">
        <Link to="/" className="navbar-brand fs-3">10man Hub</Link>

        {/* Hamburger button */}
        <button 
          className="navbar-toggler" 
          type="button" 
          data-bs-toggle="collapse" 
          data-bs-target="#navbarContent" 
          aria-controls="navbarContent" 
          aria-expanded="false" 
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible nav links */}
        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link to="/team-generator" className="nav-link fs-5 px-3">Team Generator</Link>
            </li>            
            <li className="nav-item">
              <Link to="/leaderboard" className="nav-link fs-5 px-3">Leaderboard</Link>
            </li>
            <li className="nav-item">
              <Link to="/skillSuggestion" className="nav-link fs-5 px-3">Skill Adjustment</Link>
            </li>
            <li className="nav-item">
              <Link to="/players" className="nav-link fs-5 px-3">Player Management</Link>
            </li>
            <li className="nav-item">
              <Link to="/stat-upload" className="nav-link fs-5 px-3">Stat Management</Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
